import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import EventModel from "../../components/Model/EventModel";
import { AuthService, EventService } from "../../services";
import EventLocationDetails from "../../feature/Event/Location-Details";
import EventCoverPicture from "../../feature/Event/Cover-Picture";
import EventAdvanceOption from "../../feature/Event/Advance-Option";
import { injectModels } from "../../redux/injectModels";
import { routes } from "../../constants/routes";
import Editor from "react-simple-wysiwyg";
//import { Modal, Button } from "react-bootstrap";
import { EventContractService } from "../../services";

import { useNavigate, useParams } from "react-router-dom";
import {
  eventsAddUpdate,
  getEventActiveCategoryList,
  //getEventStatusList,
  getEventById,
} from "../../services/EventService";
import { EventStatus } from "../../constants/Enum";
import { handleConsoleError } from "../../utils/common-methods";

const CreateEvent = (props) => {
  const [eventData, setEventData] = useState({
    ...EventModel,
    eventStatusId: EventStatus.Draft,
  });
  const [eventTypeList, setEventTypeList] = useState([]);
  //const [eventStatusList, setEventStatusList] = useState([]);
  const [selectedEventType, setSelectedEventType] = useState("");
  //const [selectedEventStatus, setSelectedEventStatus] = useState("");
  const [step, setStep] = useState(1);
  //const [pendingStatus, setPendingStatus] = useState(null);
  // const [showModal, setShowModal] = useState(false);
  const { eventId } = useParams();

  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    getValues,
    setError,
    clearErrors,
    watch,
    formState: { errors },
  } = useForm();

  const loginUser = AuthService.getLoginUser();

  const handlePrevious = () => {
    setStep((prevStep) => prevStep - 1);
    clearErrors();
    getEvent();
  };

  const getEvent = async () => {
    try {
      const eventTypeList = await getEventActiveCategoryList();
      //const eventStatusList = await getEventStatusList();
      setEventTypeList(eventTypeList.data || []);
      // const eventStatusListWithOutFilter = eventStatusList.data || [];
      // const eventStatusFilter = eventStatusListWithOutFilter.filter(
      //   (status) => status.id !== 2 && status.id !== 6 && status.id !== 7
      // );
      // setEventStatusList(eventStatusFilter || []);
      const eventData = (eventId && (await getEventById(eventId))) || [];
      const eventMappedData = {
        ...EventModel,
        eventStatusId: EventStatus.Draft,
        ...eventData?.data,
      };
      reset(eventMappedData);
      setEventData(eventMappedData);
      if (eventData && eventData?.data) {
        setSelectedEventType(eventData?.data?.eventCategoryTypeId);
        // setSelectedEventStatus(eventData?.data?.eventStatusId);
      }
      // if (eventMappedData && eventMappedData.id?.length > 2) {
      //   EventService.setSelectedEvent({
      //     id: eventMappedData.id,
      //     name: eventMappedData.eventName,
      //     status: eventMappedData.eventStatusId,
      //   });
      // } else {
      //   EventService.removeSelectedEvent();
      // }
    } catch (error) {
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };
  useEffect(() => {
    getEvent();
  }, []);

  const onSubmit = async (data) => {
    try {
      props.application.setLoading(true);
      data.userId = loginUser?.id;
      data.eventCategoryTypeId =
        data.eventCategoryTypeId === "" ? null : data.eventCategoryTypeId;
      data.eventStatusId =
        data.eventStatusId === "" ? EventStatus.Draft : data.eventStatusId;
      if (data.countryId === "") {
        data.countryId = null;
      }
      if (data.stateId === "") {
        data.stateId = null;
      }
      data.id =
        eventData.id === "" || eventData.id === "" ? null : eventData.id;
      data.eventCategoryTypeId =
        data.eventCategoryTypeId === "" ? null : data.eventCategoryTypeId;
      const response = await eventsAddUpdate(data);
      if (response?.isSuccess) {
        if (data.id === null) {
          // await CreateContract(response?.data?.id);
        }
        if (!eventId || eventId === "") {
          // EventService.setSelectedEvent({
          //   id: response?.data?.id,
          //   name: response?.data?.eventName,
          //   status: response?.data?.eventStatusId,
          // });
          //routes.ACCOUNT_EDIT_EVENT+"/:eventId"
          navigate(
            routes.ACCOUNT_EDIT_EVENT.replace(":eventId", response?.data?.id)
          ); //
        }

        props.application.setLoading(false);
        toast.success(response?.message);
        const eventMappedData = { ...EventModel, ...response?.data };
        setEventData(eventMappedData);
        if (step === 2 && data.eventStatusId === EventStatus.Draft) {
          await CreateContract(response?.data?.id);
        }
        if (step === 4) {
          // EventService.removeSelectedEvent();
          navigate(routes.ACCOUNT_EVENTS);
        } else {
          setStep((prevStep) => prevStep + 1);
          // EventService.setSelectedEvent({
          //   id: data?.id,
          //   name: data?.eventName,
          //   status: data?.eventStatusId,
          // });
        }
      } else {
        props.application.setLoading(false);
        toast.error(response?.message);
      }
    } catch (error) {
      props.application.setLoading(false);
      const message=handleConsoleError(error)
      toast.error(error?.message||message);
    }
  };

  const onSubmitPublish = async (data) => {
    data.userId = loginUser?.id;
    data.eventCategoryTypeId =
      data.eventCategoryTypeId === "" ? null : data.eventCategoryTypeId;
    data.eventStatusId =
      data.eventStatusId === "" ? EventStatus.Draft : data.eventStatusId;
    if (data.countryId === "") {
      data.countryId = null;
    }
    if (data.stateId === "") {
      data.stateId = null;
    }
    data.id = eventData.id === "" || eventData.id === "" ? null : eventData.id;
    const request = {
      eventId: data.id,
      eventStatus: EventStatus.Awaiting,
    };
    try {
      props.application.setLoading(true);
      data.eventStatusId = EventStatus.Awaiting;
      await eventsAddUpdate(data);
      const response = await EventService.UpdateEventStatus(request);
      if (response?.isSuccess) {
        // await CreateContract(eventId);
        props.application.setLoading(false);
        // EventService.removeSelectedEvent();
        navigate(routes.ACCOUNT_EVENTS);
        toast.success(response?.message);
      }
      props.application.setLoading(false);
    } catch (error) {
      props.application.setLoading(false);
       const message=handleConsoleError(error)
      toast.error(error?.message || message);
    }
  };

  const handleDescription = (e) => {
    const val = e.target.value;

    setEventData({ ...eventData, eventDescription: val });
    setValue("eventDescription", val);
  };

  // const confirmChange = () => {
  //   setSelectedEventStatus(pendingStatus);
  //   setShowModal(false);
  // };

  const CreateContract = async (EventId) => {
    if (EventId && EventId.length > 0) {
       props.application.setLoading(true);
      await getEventContractFinalEmailAdd(EventId, "FinalEmailRetailers");
      await getEventContractFinalEmailAdd(EventId, "FinalEmailCaterers");
      await getEventContractTermAndConditionAdd(
        EventId,
        "TermsAndConditionRetailers"
      );
      await getEventContractTermAndConditionAdd(
        EventId,
        "TermsAndConditionCaterers"
      );
      await getEventContractHandBooks(EventId, "HandbookRetailers");
      await getEventContractHandBooks(EventId, "HandbookCaterers");
    }
      props.application.setLoading(false);
  };

  const getEventContractFinalEmailAdd = async (EventId, ContractType) => {
    try {
      await EventContractService.getEventContractFinalEmailAdd(
        EventId,
        ContractType
      );
    } catch (error) {
       const message= handleConsoleError(error);
       props.application.setLoading(false);
      toast.error(error?.message|| message);
    }
  };

  const getEventContractTermAndConditionAdd = async (EventId, ContractType) => {
    try {
      await EventContractService.getEventContractTermAndConditionAdd(
        EventId,
        ContractType
      );
    } catch (error) {
     const message= handleConsoleError(error);
      props.application.setLoading(false);
      toast.error(error?.message|| message);
    }
  };

  const getEventContractHandBooks = async (EventId, ContractType) => {
    try {
      await EventContractService.getEventContractHandBooks(
        EventId,
        ContractType
      );
    } catch (error) {
     const message= handleConsoleError(error);
      props.application.setLoading(false);
      toast.error(error?.message|| message);
    }
  };

  return (
    <React.Fragment>
      {/* {!selectedEvent && (
        <section className="subscription-banner">
          <div className="container">
            <h3>{selectedEvent?.id ? "Edit Event" : "Create Event"}</h3>
          </div>
        </section>
      )} */}
      <section className="create-an-events mt-0">
        <div className="container">
          <div className="create-steps">
            <ul className="cd-breadcrumb triangle nav nav-tabs" role="tablist">
              <li
                role="presentation"
                className={`step ${
                  step === 1 ||
                  step === 2 ||
                  step === 3 ||
                  step === 4 ||
                  step === 5
                    ? "active"
                    : ""
                }`}
              >
                <span
                  aria-controls="ideate"
                  role="tab"
                  data-toggle="tab"
                  aria-expanded="true"
                >
                  General Info
                </span>
              </li>
              <li
                role="presentation"
                className={`step ${
                  step === 2 || step === 3 || step === 4 || step === 5
                    ? "active"
                    : ""
                }`}
              >
                <span
                  aria-controls="submit"
                  role="tab"
                  data-toggle="tab"
                  aria-expanded="false"
                >
                  Location
                </span>
              </li>
              <li
                role="presentation"
                className={`step ${
                  step === 3 || step === 4 || step === 5 ? "active" : ""
                }`}
              >
                <span
                  aria-controls="discuss"
                  role="tab"
                  data-toggle="tab"
                  aria-expanded="false"
                >
                  Cover Picture
                </span>
              </li>
              <li
                role="presentation"
                className={`step ${step === 4 || step === 5 ? "active" : ""}`}
              >
                <span
                  aria-controls="get-validated"
                  role="tab"
                  data-toggle="tab"
                  aria-expanded="false"
                >
                  Advance Options
                </span>
              </li>
            </ul>
            <div className="tab-content">
              <Form onSubmit={handleSubmit(onSubmit)}>
                {step === 1 && (
                  <div className="tab-pane">
                    <h2>Let's get started on building your event</h2>

                    <Form.Group controlId="eventName" className="mb-3">
                      <Form.Label>
                        Event Name <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        maxLength={100}
                        type="text"
                        {...register("eventName", {
                          required: "Event name is required",
                        })}
                        onChange={(e) => {
                          const value = e.target.value;
                          setValue(
                            "eventName",
                            value?.charAt(0)?.toUpperCase() + value?.slice(1)
                          );
                        }}
                        defaultValue={eventData?.eventName}
                      />
                      {errors.eventName && (
                        <span className="text-danger">
                          {errors.eventName?.message}
                        </span>
                      )}
                    </Form.Group>
                    <Form.Group controlId="eventType" className="mb-3">
                      <Form.Label>Event Type</Form.Label>
                      <Form.Control
                        as="select"
                        {...register("eventCategoryTypeId")}
                        value={selectedEventType}
                        onChange={(e) => {
                          const eventTypeId = e.target.value;
                          setSelectedEventType(eventTypeId);
                        }}
                      >
                        <option value="">Select Event Type</option>
                        {eventTypeList.map((event) => (
                          <option key={event?.id} value={event?.id}>
                            {event?.name}
                          </option>
                        ))}
                      </Form.Control>
                      {errors.event && (
                        <span className="text-danger">
                          {errors.event?.message}
                        </span>
                      )}
                    </Form.Group>
                    <Form.Group controlId="eventStatusId">
                      <Form.Control
                        type="hidden"
                        {...register("eventStatusId")}
                        value={eventData?.eventStatusId}
                      />
                    </Form.Group>

                    <Form.Group controlId="eventDescription" className="mb-3">
                      <Form.Label>Description</Form.Label>
                      <Editor
                        style={{ height: "200px" }}
                        value={eventData?.eventDescription}
                        onChange={handleDescription}
                      />
                      {errors.eventDescription && (
                        <span className="text-danger">
                          {errors.eventDescription?.message}
                        </span>
                      )}
                    </Form.Group>
                  </div>
                )}

                {step === 2 && (
                  <div className="tab-pane">
                    <EventLocationDetails
                      reset={reset}
                      register={register}
                      errors={errors}
                      setValue={setValue}
                      getValues={getValues}
                      setEventData={setEventData}
                      eventData={eventData}
                      setError={setError}
                      clearErrors={clearErrors}
                      watch={watch}
                      step={step}
                      props={props}
                    />
                  </div>
                )}

                {step === 3 && (
                  <div className="tab-pane">
                    <EventCoverPicture
                      eventData={eventData}
                      setEventData={setEventData}
                    />
                  </div>
                )}

                {step === 4 && (
                  <div className="tab-pane">
                    <EventAdvanceOption
                      register={register}
                      errors={errors}
                      eventData={eventData}
                      setEventData={setEventData}
                      setValue={setValue}
                      getValues={getValues}
                    ></EventAdvanceOption>
                  </div>
                )}
              </Form>

              <div className="navigation-buttons mt-3 mb-3 px-2">
                {step > 1 && (
                  <button type="button" onClick={handlePrevious}>
                    Previous
                  </button>
                )}
                {step < 4 && (
                  <button type="button" onClick={handleSubmit(onSubmit)}>
                    Next
                  </button>
                )}
                {step === 4 && (
                  <React.Fragment>
                    <div>
                      {eventData.eventStatusId !== EventStatus.Awaiting && (
                        <button
                          type="button"
                          onClick={handleSubmit(onSubmitPublish)}
                          className="me-2"
                        >
                          Publish Request to Admin
                        </button>
                      )}

                      <button type="button" onClick={handleSubmit(onSubmit)}>
                        Save
                      </button>
                    </div>
                  </React.Fragment>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Status Change</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to change the event status to "
          {eventStatusList.find((s) => s.id === pendingStatus)?.eventStatusName}
          "?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={confirmChange}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal> */}
    </React.Fragment>
  );
};

export default injectModels(["application"])(CreateEvent);
